/* ==========================================================================
   UI - comportamento das dobras
   Regras de movimento herdadas de _base/fg-store/docs/MOTION.md:
   nada aparece do nada; ease/linear crus sao proibidos; rodizio nao retoma.
   ========================================================================== */
(function () {
  'use strict';
  const reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- D1 faixa de condicoes -------------------------------------------
     Para de vez no primeiro gesto: retomar sozinho tira do usuario o que ele
     acabou de pegar. A barra de tempo some junto, porque barra correndo sem
     nada para contar e mentira. */
  (function faixa() {
    const txt = document.getElementById('faixa-texto');
    if (!txt) return;
    /* ⚠️ "em produtos selecionados" é obrigatório (JM, 13/09/2026): o
       pagamento na entrega NÃO vale para o catálogo inteiro. Sem a
       ressalva, a faixa promete o que o checkout nega.
       1.3.7 (30/09/2026): as frases vêm do #bv-faixa do cabeçalho, que já
       segue o país (sem COD = só cartão) e o idioma. A lista fixa em
       espanhol mostrava "Pago contra reembolso en España, Portugal e
       Italia" até para os EUA e o Leste. */
    let itens = [];
    try { itens = JSON.parse(document.getElementById('bv-faixa').textContent).filter(Boolean); } catch (e) {}
    if (!itens.length) itens = [txt.textContent.trim()].filter(Boolean);
    if (!itens.length) return;
    let i = 0, timer = null, parado = reduz;

    /* ⚠️ A BARRA DE TEMPO SAIU (JM, 16/09/2026). A troca agora é uma
       passagem lateral - o texto sai para um lado e o próximo entra pelo
       outro, no sentido da seta tocada -, na troca automática e na manual. */
    let trocando = null;
    function mostra(n, dir) {
      const novo = (n + itens.length) % itens.length;
      if (novo === i && txt.textContent) return;
      i = novo;
      clearTimeout(trocando);
      if (reduz || !dir) { txt.textContent = itens[i]; }
      else {
        txt.style.setProperty('--dx', (dir > 0 ? -1 : 1) * 18 + 'px');
        txt.classList.add('sai');
        trocando = setTimeout(function () {
          txt.textContent = itens[i];
          txt.style.setProperty('--dx', (dir > 0 ? 1 : -1) * 18 + 'px');
          txt.classList.remove('sai');
          txt.classList.add('entra');
          void txt.offsetWidth;
          txt.classList.remove('entra');
        }, 220);
      }
      if (!parado) { clearTimeout(timer); timer = setTimeout(() => mostra(i + 1, 1), 5000); }
    }
    function para() { parado = true; clearTimeout(timer); }
    document.querySelectorAll('[data-faixa]').forEach(b =>
      b.addEventListener('click', function () { para(); mostra(i + Number(b.dataset.faixa), Number(b.dataset.faixa)); }));
    txt.textContent = '';
    mostra(0);
  })();

  /* --- D2 cabecalho flutuante: dois limiares ----------------------------
     limiar 1: saiu do topo  -> ganha superficie (antes ele e transparente
               sobre o heroi, que e a integracao pedida)
     limiar 2: passou o heroi -> encolhe e recolhe a faixa de condicoes
     O limiar 2 e MEDIDO na altura do heroi, nao um numero fixo: o heroi e
     `100svh` e muda de altura em cada aparelho. Um 180px cravado encolheria
     o cabecalho no meio do banner num monitor e depois dele num celular. */
  (function cabecalho() {
    const cab = document.getElementById('cab');
    const heroi = document.getElementById('heroi-palco');
    if (!cab) return;
    let ticking = false, limiar2 = 400;

    function medir() {
      limiar2 = heroi ? Math.max(240, heroi.getBoundingClientRect().height - 120) : 400;
    }
    function ler() {
      const y = window.scrollY;
      /* Página interna (blog, artigo) não tem herói escuro atrás: o cabeçalho
         nasce e fica no estado de ferramenta. Transparente sobre fundo liso,
         ele sumiria sem integrar com nada. */
      cab.classList.toggle('l1', y > 8 || document.body.classList.contains('interna'));
      cab.classList.toggle('l2', y > limiar2);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(ler); }
    }, { passive: true });
    window.addEventListener('resize', function () { medir(); ler(); }, { passive: true });
    medir(); ler();
  })();

  /* --- D2 busca em tela ---------------------------------------------------
     O cabecalho limpo usa icone, nao campo. Numa loja de 1.595 produtos
     enterrar a busca custa achabilidade, entao o icone abre uma camada de
     largura inteira - um clique de distancia, e o foco vai direto pro campo.
     Sem isso o teclado teria que tabular a pagina toda ate achar o campo que
     acabou de aparecer. */
  (function buscaTela() {
    const btn = document.getElementById('btn-busca');
    const tela = document.getElementById('busca-tela');
    const campo = document.getElementById('busca');
    const fechar = document.getElementById('fechar-busca');
    if (!btn || !tela) return;
    let voltarPara = null;

    function abre() {
      voltarPara = document.activeElement;
      tela.hidden = false;
      void tela.offsetHeight;
      tela.classList.add('aberto');
      btn.setAttribute('aria-expanded', 'true');
      campo.focus();
    }
    function fecha() {
      tela.classList.remove('aberto');
      tela.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      const sug = document.getElementById('busca-sug');
      if (sug) sug.hidden = true;
      /* Devolve o foco a quem abriu: sem isso o teclado volta pro topo da
         pagina e a pessoa perde o lugar. */
      if (voltarPara) voltarPara.focus();
    }
    btn.addEventListener('click', abre);
    if (fechar) fechar.addEventListener('click', fecha);
    tela.addEventListener('click', ev => { if (ev.target === tela) fecha(); });
    document.addEventListener('keydown', ev => {
      if (ev.key === 'Escape' && !tela.hidden) fecha();
    });
  })();

  /* --- 1.3.10 busca preditiva (JM, 01/10/2026) ------------------------------
     A cada letra (com 180 ms de folga) pergunta à Shopify quais produtos
     combinam com as palavras digitadas - a última vale como começo de palavra
     ("altavoz port" já acha "Altavoz Portátil") - e mostra até 6 com foto e
     preço, mais "Ver todo" para a busca completa. Setas ↑/↓ andam pela lista;
     Enter sem item escolhido segue para a página de busca, como antes.
     Vale para a busca do cabeçalho e para o campo do herói da home.

     1.4.9 (JM, 08/10/2026): "o cliente não tem que digitar o nome exato".
     A busca da Shopify já ignora acento, aceita erro leve e entende sinônimo
     ("bocina" acha altavoz); o que faltava, medido em 08/10:
       - completar o TERMO enquanto digita ("secad" -> "secador de pelo"),
         com as expressões que existem nos títulos do catálogo
         (assets/busca-termos-<idioma>.js, gerado por scripts/gerar-termos-busca.py);
       - corrigir erro pesado que a Shopify não pega ("blutut" -> bluetooth):
         palavra fora do catálogo vira a mais próxima que existe nele (mesma
         primeira letra, 1-2 letras de diferença) ou a de mesmo som sem vogais;
       - mostrar a categoria quando o termo bate com ela;
       - contar e paginar só produto (antes a contagem somava páginas e
         artigos do blog e a grade mostrava menos cards do que dizia).

     1.5.3 (JM, 15/10/2026): "a lista está cortada; quero ela completa, com
     rolagem, e as sugestões mais próximas do que foi digitado".
       - A lista do herói morava dentro do formulário (que tem backdrop-filter)
         dentro do palco (overflow: hidden): abria com 399px e o palco cortava
         no meio. Agora, aberta, ela sai para o <body>, fica fixa logo abaixo do
         campo e desce até o fim da área visível (no celular, acima do
         teclado), com rolagem própria; ao fechar volta para o lugar.
       - Termo que só muda por espaço ou hífen ("green lyca"/"greenlyca") vira
         um só; palavra única também completa pelo começo de QUALQUER palavra
         do termo; vale a partir da primeira letra.
       - Produtos: além da busca normal (que mistura sentido - "green" trazia
         "Mala Verde" antes de "Smartwatch Green Lyca"), uma busca só no título;
         as duas se juntam e se ordenam pelo quanto o título bate com o que foi
         digitado: palavra inteira > título começa com o texto > começo de
         palavra > trecho; a ordem da Shopify desempata. Até 8, com rolagem. */
  const norm = s => String(s).toLowerCase().normalize('NFD').replace(/\p{M}/gu, '')
    .replace(/\u0142/g, 'l').replace(/\u0111/g, 'd').replace(/\u00df/g, 'ss').replace(/\s+/g, ' ').trim();
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const buscaCfg = (function () {
    const el = document.getElementById('bv-busca');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  })();

  /* Mesmo som, outra grafia: tira vogal e letra muda, junta as trocas comuns
     de quem escreve de ouvido ("blutut" e "bluetooth" viram "bltt"). */
  function esqueleto(w) {
    return w.replace(/ph/g, 'f').replace(/th/g, 't').replace(/ck|qu|q/g, 'k').replace(/c(?=[aou])/g, 'k')
      .replace(/z/g, 's').replace(/v/g, 'b').replace(/ll|y/g, 'i').replace(/h/g, '')
      .replace(/[aeiou]/g, '').replace(/(.)\1+/g, '$1');
  }
  /* Distância de edição com troca de vizinhas ("auricualres"); para cedo
     quando já passou do limite. */
  function distancia(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    const m = a.length, n = b.length, d = [];
    for (let i = 0; i <= m; i++) { d[i] = [i]; }
    for (let j = 1; j <= n; j++) d[0][j] = j;
    for (let i = 1; i <= m; i++) {
      let menor = Infinity;
      for (let j = 1; j <= n; j++) {
        const custo = a[i - 1] === b[j - 1] ? 0 : 1;
        let v = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + custo);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, d[i - 2][j - 2] + 1);
        d[i][j] = v; if (v < menor) menor = v;
      }
      if (menor > max) return max + 1;
    }
    return d[m][n];
  }

  /* Vocabulário do idioma da página, baixado uma vez, no primeiro uso. */
  let termosPromessa = null;
  function carregaTermos() {
    if (termosPromessa) return termosPromessa;
    termosPromessa = new Promise(function (ok) {
      if (!buscaCfg.termos) return ok(null);
      window.BVTermos = null;
      const s = document.createElement('script');
      s.src = buscaCfg.termos; s.async = true;
      s.onload = function () { ok(prepara(window.BVTermos)); };
      s.onerror = function () { ok(null); };
      document.head.appendChild(s);
    });
    return termosPromessa;
  }
  function prepara(d) {
    if (!d || !d.p) return null;
    const todos = d.p.map(x => ({ f: x[0], k: norm(x[0]), c: x[1] }));
    const pal = new Map(), som = new Map();
    todos.forEach(e => { if (e.k.indexOf(' ') < 0) pal.set(e.k, e); });
    /* 1.5.3: a lista vem da mais buscada para a menos; a primeira grafia de
       cada termo (sem espaço e hífen) fica, as outras saem da sugestão. */
    const vistos = new Set();
    const exp = todos.filter(function (e) {
      e.j = e.k.replace(/[\s-]+/g, '');
      if (vistos.has(e.j)) return false;
      vistos.add(e.j); return true;
    });
    pal.forEach(e => {
      if (e.k.length < 4) return;
      const s = esqueleto(e.k);
      if (s.length >= 3 && (!som.has(s) || som.get(s).c < e.c)) som.set(s, e);
    });
    /* livre = palavra certa que não está nos títulos (regionalismo como
       "celular", "bocina"): a Shopify já entende pelo sentido, não se corrige. */
    return { t: d.t || {}, exp: exp, pal: pal, som: som, livre: new Set((d.x || []).map(norm)) };
  }

  /* Corrige só a palavra que NÃO existe no catálogo (a última vale também
     como começo de palavra). Devolve null quando não há o que corrigir, ou
     { q, forte }: forte = 1 letra de diferença na palavra inteira (5+ letras),
     ou mesmo som com a mesma primeira letra. Correção fraca ("celular" -> "células") nunca
     passa por cima do que a Shopify achou; só entra quando ela não acha nada. */
  function corrige(q, T) {
    if (!T) return null;
    const tk = norm(q).split(' ').filter(Boolean);
    let mudou = false, forte = true;
    const saida = tk.map(function (t, i) {
      const ultimo = i === tk.length - 1;
      if (t.length < 4 || /\d/.test(t) || T.pal.has(t) || T.livre.has(t)) return t;
      if (ultimo) { for (const k of T.pal.keys()) if (k.startsWith(t)) return t; }
      const max = t.length >= 7 ? 2 : 1;
      let melhor = null, bd = max + 1, inteira = max + 1;
      T.pal.forEach(function (e, k) {
        if (k[0] !== t[0] || k.length < 4) return;
        const di = distancia(t, k, max);
        let d = di;
        if (ultimo && k.length > t.length) d = Math.min(d, distancia(t, k.slice(0, t.length), max));
        if (d < bd || (d === bd && melhor && e.c > melhor.c)) { bd = d; melhor = e; inteira = di; }
      });
      if (melhor) { if (inteira > 1 || t.length < 5) forte = false; }
      else {
        const s = esqueleto(t), e = s.length >= 3 ? T.som.get(s) : null;
        if (e && e.k[0] === t[0] && t.length >= 5) melhor = e;
      }
      if (!melhor) return t;
      mudou = true; return melhor.f;
    });
    return mudou ? { q: saida.join(' '), forte: forte } : null;
  }

  /* Termos que completam o que foi digitado: primeiro os que COMEÇAM com o
     texto, depois os que têm todas as palavras digitadas em qualquer ordem. */
  function completa(q, T, lim) {
    if (!T) return [];
    const k = norm(q); if (!k) return [];
    const kj = k.replace(/[\s-]+/g, '');
    const tk = k.split(' ');
    const a = [], b = [];
    for (const e of T.exp) {
      if (e.k === k || e.j === kj) continue;
      if (e.k.startsWith(k) || (kj.length >= 4 && e.j.startsWith(kj))) { if (a.length < lim) a.push(e); }
      else if (b.length < lim && (tk.length > 1 || k.length >= 2)) {
        /* 1.5.3: também com uma palavra só ("lyca" acha "green lyca"). */
        const ws = e.k.split(/[\s-]+/);
        if (tk.every(t => ws.some(w => w.startsWith(t)))) b.push(e);
      }
      if (a.length >= lim) break;
    }
    return a.concat(b).slice(0, lim);
  }
  /* 1.5.3: quanto o título bate com o que foi digitado (0 = só por sentido,
     palpite da Shopify). A última palavra vale como começo de palavra. */
  function pontua(titulo, q) {
    const k = norm(q), t = norm(titulo);
    const ws = t.split(/[^\p{L}\p{N}]+/u).filter(Boolean), junto = ws.join('');
    const tk = k.split(' ').filter(Boolean);
    let p = t.startsWith(k) ? 40 : 0, todas = true;
    tk.forEach(function (x, i) {
      if (ws.indexOf(x) > -1) p += 30;
      else if (ws.some(w => w.startsWith(x))) p += i === tk.length - 1 ? 24 : 16;
      else if (x.length >= 3 && junto.indexOf(x) > -1) p += 8;
      else todas = false;
    });
    return todas && tk.length ? p + 50 : p;
  }
  function ordena(lista, q) {
    return lista.map((p, i) => ({ p: p, i: i, s: pontua(p.title, q) }))
      .sort((a, b) => b.s - a.s || a.i - b.i).map(x => x.p);
  }
  function categorias(q) {
    const tk = norm(q).split(' ').filter(t => t.length >= 3);
    if (!tk.length) return [];
    return (buscaCfg.cats || []).filter(function (c) {
      const ws = norm(c[0]).split(/[^a-z0-9À-῿]+/);
      return tk.some(t => ws.some(w => w.length >= 3 && w.startsWith(t)));
    }).slice(0, 2);
  }
  function urlBusca(q, extra) {
    const loja = (window.BV && BV.loja) || {};
    return (loja.busca || '/search') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last' + (extra || '');
  }
  /* Nenhum título traz a palavra digitada: o que a Shopify devolveu é
     palpite por semelhança, e a correção tende a ser o que a pessoa quis. */
  function semPalavra(q, titulos) {
    const tk = norm(q).split(' ').filter(t => t.length >= 4);
    if (!tk.length) return false;
    return titulos.every(function (t) {
      const ws = norm(t).split(/[^a-z0-9À-῿]+/);
      return !tk.some(x => ws.some(w => w.startsWith(x)));
    });
  }

  (function buscaPreditiva() {
    if (!window.fetch) return;
    [['busca', 'busca-sug'], ['heroi-busca', 'heroi-sug']].forEach(function (par) {
      const campo = document.getElementById(par[0]);
      const lista = document.getElementById(par[1]);
      if (campo && lista) liga(campo, lista);
    });
    function liga(campo, lista) {
    const loja = (window.BV && BV.loja) || {};
    const rotaBusca = loja.busca || '/search';
    const preco = v => (window.BV && BV.dinheiro) ? BV.dinheiro(Math.round(parseFloat(v) * 100)) : v;
    const lupa = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';
    let tempo = null, pedido = null, ativo = -1;
    /* 1.5.3: a lista do herói sai do palco (overflow: hidden) enquanto está
       aberta; o comentário marca o lugar para onde ela volta. */
    const solta = lista.classList.contains('hx__sug');
    const lugar = document.createComment('sug');
    function fundoVisivel() {
      const vv = window.visualViewport;
      return vv ? vv.offsetTop + vv.height : window.innerHeight;
    }
    function posiciona() {
      if (lista.hidden) return;
      const fundo = fundoVisivel();
      if (solta && campo.form) {
        const r = campo.form.getBoundingClientRect();
        lista.style.left = r.left + 'px';
        lista.style.width = r.width + 'px';
        lista.style.top = (r.bottom + 8) + 'px';
        lista.style.maxHeight = Math.max(160, fundo - r.bottom - 20) + 'px';
      } else {
        lista.style.maxHeight = Math.max(160, fundo - lista.getBoundingClientRect().top - 12) + 'px';
      }
    }
    function abre() {
      if (solta && lista.parentNode !== document.body) {
        lista.parentNode.insertBefore(lugar, lista);
        document.body.appendChild(lista);
        lista.classList.add('hx__sug--solta');
        /* Pouco espaço embaixo (celular com teclado, texto do herói no pé da
           tela): sobe a página até o campo ficar logo abaixo do cabeçalho. */
        const r = campo.form ? campo.form.getBoundingClientRect() : null;
        if (r && fundoVisivel() - r.bottom < 280) {
          const cab = document.querySelector('.cab');
          const topo = (cab ? cab.getBoundingClientRect().bottom : 0) + 12;
          /* instant: o html tem scroll-behavior: smooth, e a lista tem de
             abrir já no lugar, sem disputar com a rolagem do teclado. */
          if (r.top > topo) window.scrollBy({ top: r.top - topo, behavior: 'instant' });
        }
      }
      posiciona();
    }
    function devolve() {
      if (!solta || !lugar.parentNode) return;
      lugar.parentNode.insertBefore(lista, lugar);
      lugar.remove();
      lista.classList.remove('hx__sug--solta');
      ['left', 'width', 'top', 'maxHeight'].forEach(p => { lista.style[p] = ''; });
    }
    window.addEventListener('scroll', posiciona, { passive: true });
    window.addEventListener('resize', posiciona);
    if (window.visualViewport) {
      visualViewport.addEventListener('resize', posiciona);
      visualViewport.addEventListener('scroll', posiciona);
    }

    function itens() { return Array.from(lista.querySelectorAll('a[role="option"]')); }
    function marca(k) {
      const xs = itens();
      xs.forEach((a, i) => a.setAttribute('aria-selected', String(i === k)));
      ativo = k;
      if (k >= 0 && xs[k]) { campo.setAttribute('aria-activedescendant', xs[k].id); xs[k].scrollIntoView({ block: 'nearest' }); }
      else campo.removeAttribute('aria-activedescendant');
    }
    function esconde() {
      lista.hidden = true; lista.innerHTML = '';
      campo.setAttribute('aria-expanded', 'false'); marca(-1);
      devolve();
    }
    /* Parte digitada normal, o que completa em negrito (como no Google). */
    function realce(f, q) {
      const n = norm(q).length;
      return norm(f).startsWith(norm(q)) ? esc(f.slice(0, n)) + '<b>' + esc(f.slice(n)) + '</b>' : esc(f);
    }
    function mostra(q, r) {
      const T = r.T || { t: {} }, tx = T.t || {};
      let n = 0, h = '';
      const id = () => 'bsug-' + campo.id + '-' + (n++);
      if (r.nota) h += '<p class="sug__nota">' + r.nota + '</p>';
      r.termos.forEach(function (e) {
        h += '<a role="option" id="' + id() + '" aria-selected="false" class="sug__termo" href="' + esc(urlBusca(e.f)) + '">' + lupa + '<span>' + realce(e.f, q) + '</span></a>';
      });
      r.cats.forEach(function (c) {
        h += '<a role="option" id="' + id() + '" aria-selected="false" class="sug__termo sug__cat" href="' + esc(c[1]) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>' +
          '<span>' + esc(c[0]) + '</span><small>' + esc(tx.categoria || '') + '</small></a>';
      });
      if (r.produtos.length) {
        if (h) h += '<hr class="sug__div">';
        h += r.produtos.map(p =>
          '<a role="option" id="' + id() + '" aria-selected="false" href="' + esc(p.url) + '">' +
            (p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=96" alt="" width="44" height="44" loading="lazy">' : '<img alt="" width="44" height="44">') +
            '<span>' + esc(p.title) + '</span><em>' + esc(preco(p.price)) + '</em></a>').join('') +
          '<a role="option" id="' + id() + '" aria-selected="false" class="sug__todos" href="' + esc(urlBusca(r.qFinal)) + '"><span>' + esc(lista.dataset.ver || '') + ' &rarr;</span></a>';
      } else if (!h) {
        h = '<p class="sug__vazio">' + esc(lista.dataset.sem || '') + '</p>';
      }
      lista.innerHTML = h;
      lista.hidden = false; campo.setAttribute('aria-expanded', 'true'); marca(-1);
      lista.scrollTop = 0;
      abre();
    }
    function sugere(q, sinal, termo) {
      /* Pede 10 e mostra 6: a cópia "regional" (mesmo item de outro depósito)
         só vale no país do pagamento na entrega dela; fora dele o card já a
         esconde, e a lista mostrava produto repetido. */
      const url = rotaBusca + '/suggest.json?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=10&resources%5Boptions%5D%5Bunavailable_products%5D=last';
      const codPais = 'cod-' + (buscaCfg.pais || '');
      const pede = u => fetch(u, { signal: sinal, headers: { accept: 'application/json' } })
        .then(r => r.json()).then(d => (((d.resources || {}).results || {}).products || []))
        .catch(e => { if (e && e.name === 'AbortError') throw e; return []; });
      /* 1.5.3: a busca só no título traz primeiro quem tem a palavra no nome;
         a normal completa com o que a Shopify acha pelo sentido. Com pouca
         letra a Shopify lê pelo sentido ("gre" vira cinzento/grey) e não como
         começo de palavra: o termo mais buscado que completa o texto
         ("green") entra como terceira busca, só no título. */
      const soTitulo = '&resources%5Boptions%5D%5Bfields%5D=title';
      const pedidos = [pede(url + soTitulo), pede(url)];
      if (termo && norm(termo) !== norm(q)) pedidos.push(pede(url.replace('q=' + encodeURIComponent(q), 'q=' + encodeURIComponent(termo)) + soTitulo));
      return Promise.all(pedidos).then(function (rs) {
        const vistos = new Set();
        const junto = [].concat.apply([], rs).filter(function (p) {
          /* O mesmo produto volta de cada busca com outro ?_pos/_sid na url. */
          const chave = p.id || String(p.url).split('?')[0];
          if (vistos.has(chave)) return false;
          vistos.add(chave);
          const t = p.tags || [];
          return t.indexOf('regional') < 0 || t.indexOf(codPais) > -1;
        });
        return ordena(junto, q).slice(0, 8);
      });
    }
    function busca() {
      const q = campo.value.trim();
      if (!q) { esconde(); return; }
      if (pedido) pedido.abort();
      pedido = new AbortController();
      const sinal = pedido.signal;
      carregaTermos().then(function (T) {
        const t1 = completa(q, T, 1)[0];
        const termo = t1 && t1.k.startsWith(norm(q)) ? t1.f : null;
        return sugere(q, sinal, termo).then(R0 => [R0, T]);
      }).then(function (res) {
        const R0 = res[0], T = res[1];
        const c = corrige(q, T), corr = c && c.q;
        const fim = function (R1) {
          if (campo.value.trim() !== q) return;
          const tx = (T && T.t) || {};
          const r = { T: T, produtos: R0, qFinal: q, nota: '', cats: categorias(corr || q) };
          if (corr && R1 && R1.length && (!R0.length || (c.forte && semPalavra(q, R0.map(p => p.title))))) {
            const chave = p => p.id || String(p.url).split('?')[0];
            const vistos = new Set(R1.map(chave));
            r.produtos = R1.concat(R0.filter(p => !vistos.has(chave(p)))).slice(0, 8);
            r.qFinal = corr;
            r.nota = esc(tx.mostrando || '{q}').replace('{q}', '<b>' + esc(corr) + '</b>');
          }
          /* No celular 3 termos, para os produtos aparecerem sem rolar
             (1.5.3: 4 e 5 - a lista agora rola e vai até o fim da tela). */
          const lim = window.matchMedia('(max-width: 600px)').matches ? 4 : 5;
          r.termos = completa(r.qFinal, T, lim);
          if (!r.termos.length && corr) r.termos = completa(corr, T, lim);
          mostra(q, r);
        };
        if (corr) sugere(corr, sinal).then(fim).catch(() => fim(null)); else fim(null);
      }).catch(() => {});
    }
    campo.addEventListener('input', function () { clearTimeout(tempo); tempo = setTimeout(busca, 180); });
    campo.addEventListener('focus', carregaTermos, { once: true });
    campo.addEventListener('keydown', function (ev) {
      const xs = itens();
      if (lista.hidden || !xs.length) return;
      if (ev.key === 'ArrowDown') { ev.preventDefault(); marca((ativo + 1) % xs.length); }
      else if (ev.key === 'ArrowUp') { ev.preventDefault(); marca(ativo <= 0 ? xs.length - 1 : ativo - 1); }
      else if (ev.key === 'Enter' && ativo >= 0 && xs[ativo]) { ev.preventDefault(); window.location.href = xs[ativo].href; }
    });
    /* Ao fechar a camada de busca a lista some junto (o fecha() de cima já
       esconde #busca-sug); ao reabrir com texto no campo, volta a sugerir. */
    document.getElementById('btn-busca') && document.getElementById('btn-busca').addEventListener('click', function () {
      if (campo.id === 'busca' && campo.value.trim()) busca();
    });
    /* Clique fora fecha a lista do herói (a da camada fecha com a camada). */
    document.addEventListener('click', function (ev) {
      if (!lista.hidden && !lista.contains(ev.target) && ev.target !== campo) esconde();
    });
    campo.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') esconde(); });
    }
  })();

  /* --- 1.4.9 página de resultados: correção quando a busca não acha -------
     Zero resultado com palavra fora do catálogo -> refaz com a correção e
     avisa ("Mostramos resultados para bluetooth · Buscar solo blutut").
     Com resultado, mas nenhum card traz a palavra digitada -> oferece a
     correção num link ("¿Quisiste decir…?"). bv_exato=1 desliga as duas. */
  (function buscaCorrecao() {
    const topo = document.querySelector('.buscatopo[data-termo]');
    if (!topo) return;
    const termo = topo.dataset.termo || '';
    const total = parseInt(topo.dataset.total || '0', 10);
    const p = new URLSearchParams(location.search);
    const conta = document.getElementById('busca-conta');
    const aviso = function (html) {
      const el = document.createElement('p');
      el.className = 'buscatopo__correcao'; el.innerHTML = html;
      conta.parentNode.insertBefore(el, conta);
    };
    carregaTermos().then(function (T) {
      const tx = (T && T.t) || {};
      const de = p.get('bv_de');
      if (de) {
        aviso(esc(tx.mostrando || '{q}').replace('{q}', '<b>' + esc(termo) + '</b>') +
          ' · <a href="' + esc(urlBusca(de, '&bv_exato=1')) + '">' + esc(tx.so || '{q}').replace('{q}', esc(de)) + '</a>');
        return;
      }
      if (!termo || p.get('bv_exato') || !T) return;
      const c = corrige(termo, T), corr = c && c.q;
      if (!corr || norm(corr) === norm(termo)) return;
      if (total === 0) { location.replace(urlBusca(corr, '&bv_de=' + encodeURIComponent(termo))); return; }
      const nomes = Array.from(document.querySelectorAll('#busca-grade .card__nome')).map(n => n.textContent);
      if (c.forte && semPalavra(termo, nomes)) {
        aviso((tx.quis || '{q}').split('{q}').map(esc).join('<a href="' + esc(urlBusca(corr)) + '"><b>' + esc(corr) + '</b></a>'));
      }
    });
  })();

  /* --- 1.4.9 clique no WhatsApp vira evento (JM, 08/10/2026) ---------------
     O relatório mensal do contrato conta cliques no WhatsApp, e o GA4 mora
     num pixel isolado que não enxerga clique na página. Aqui o tema publica
     "bv_whatsapp" no barramento da Shopify; o pixel GA4 (v4) o transforma em
     whatsapp_click, com o lugar do botão. Só publica: quem decide se o dado
     vai ao Google é o consentimento, que o pixel já respeita.
     1.5.4 (15/10/2026): 28 dias com ZERO whatsapp_click - a loja não tinha
     link wa.me; o único WhatsApp era o botão do formulário do Releasit, que
     é <button>. Agora conta também esse botão (local "releasit") e o item
     "Apoio por WhatsApp" das garantias do produto, que virou link
     (local "garantias"). Só publica o evento; a ação do botão é do app. */
  document.addEventListener('click', function (ev) {
    const a = ev.target.closest && ev.target.closest('a[href*="wa.me"], a[href*="whatsapp.com"], a[href^="whatsapp:"], button.rsi-additionals_whatsapp_button');
    if (!a || !window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
    const secao = a.closest('[id^="shopify-section-"]');
    const local = a.closest('#rsi_form_wrapper') ? 'releasit'
      : a.closest('.wa-flutuante') ? 'flutuante'
      : a.closest('.pdp__garantias') ? 'garantias'
      : secao ? secao.id.replace('shopify-section-', '').replace(/^[a-z0-9]+__/, '') : 'pagina';
    try {
      Shopify.analytics.publish('bv_whatsapp', { local: local, pagina: location.pathname });
    } catch (e) {}
  }, true);

  /* --- 1.5.0 clique em "finalizar compra" vira evento (JM, 11/10/2026) ----
     Funil do relatório: quantos clicam para pagar × quantos compram, separado
     por forma de pagamento. Mesmo caminho do WhatsApp: o tema publica
     "bv_finalizar" e o pixel GA4 (v5) o transforma em finalizar_compra.
     - checkout: botão name="checkout" da sacola e da página do carrinho
       (cartão e demais formas, no checkout da Shopify);
     - cod: botão do Releasit (#rsi_buy_now_button) no produto, na sacola
       (#cart-wrapper) ou flutuante (#floatingBuyNowButton).
     Quem conclui já chega pelo pixel: purchase (checkout) e purchase com
     payment_type "cod" (Releasit). */
  document.addEventListener('click', function (ev) {
    const alvo = ev.target.closest && ev.target.closest('button[name="checkout"], #rsi_buy_now_button');
    if (!alvo || !window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
    const cod = alvo.id === 'rsi_buy_now_button';
    let local = 'pagina';
    if (cod) {
      local = alvo.closest('#floatingBuyNowButton') ? 'flutuante' : (alvo.closest('#cart-wrapper, #CartDrawer, cart-drawer, .sacola') ? 'sacola' : 'produto');
    } else {
      local = alvo.id === 'CartDrawer-Checkout' || alvo.closest('cart-drawer, #CartDrawer, .sacola') ? 'sacola' : 'carrinho';
    }
    try {
      Shopify.analytics.publish('bv_finalizar', { metodo: cod ? 'cod' : 'checkout', local: local, pagina: location.pathname });
    } catch (e) {}
  }, true);

  /* --- D2 painel de idioma: abre por CLIQUE ------------------------------
     Hover abre menu sem intencao e, no toque, nao existe. */
  (function idioma() {
    const btn = document.getElementById('btn-idioma');
    const painel = document.getElementById('painel-idioma');
    if (!btn || !painel) return;
    /* O `.cab` recebe `aberto` junto com o painel: é essa classe que tira os
       cantos de baixo da barra e a pinta com o mesmo fundo do painel, para os
       dois lerem como um cartão só (mesma regra do mega-menu). */
    const cab = document.getElementById('cab');
    /* ⚠️ ABRE E FECHA ANIMADO (JM, 16/09/2026): o painel desce e os itens
       entram em cascata; ao fechar, sobe antes de sair do fluxo. */
    let t = null;
    function fecha() {
      if (painel.hidden) return;
      btn.setAttribute('aria-expanded', 'false');
      painel.classList.remove('aberto');
      clearTimeout(t);
      t = setTimeout(function () { painel.hidden = true; }, 320);
    }
    function abre() {
      clearTimeout(t);
      painel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      /* 1.4.8: o painel de país virou um cartão pequeno ancorado à bandeira;
         a barra não perde mais os cantos nem muda de estado ao abri-lo. */
      void painel.offsetHeight;
      painel.classList.add('aberto');
    }
    btn.addEventListener('click', function () {
      btn.getAttribute('aria-expanded') === 'true' ? fecha() : abre();
    });
    document.addEventListener('keydown', ev => { if (ev.key === 'Escape') fecha(); });
    document.addEventListener('click', ev => {
      if (!ev.target.closest('#painel-idioma') && !ev.target.closest('#btn-idioma')) fecha();
    });

    /* Escolher um idioma troca a bandeira do botão - com um giro, para a troca
       ser vista - e traduz o site inteiro (js/i18n.js). Escolher uma moeda
       converte todos os preços da página pela cotação do BCE (js/i18n.js). */
    const pais = document.getElementById('cab-pais');
    const rot = document.getElementById('cab-pais-rot');
    function marcaBandeira(cod) {
      if (!pais) return;
      pais.classList.remove('gira'); void pais.getBoundingClientRect(); pais.classList.add('gira');
      setTimeout(() => pais.querySelector('use').setAttribute('href', '#b-' + cod), 200);
    }
    function marcaIdioma(cod) {
      const b = painel.querySelector('[data-pais="' + cod + '"]');
      if (!b) return;
      b.closest('ul').querySelectorAll('button').forEach(x => x.removeAttribute('aria-current'));
      b.setAttribute('aria-current', 'true');
      if (rot) rot.textContent = 'País e idioma: ' + b.dataset.paisNome + ', ' + b.dataset.lingua;
    }
    painel.addEventListener('click', function (ev) {
      const b = ev.target.closest('button');
      if (!b) return;
      if (b.dataset.pais) {
        marcaIdioma(b.dataset.pais);
        marcaBandeira(b.dataset.pais);
        if (window.BVI18n) BVI18n.usar(b.dataset.pais);
      } else if (b.dataset.moeda) {
        b.closest('ul').querySelectorAll('button').forEach(x => x.removeAttribute('aria-current'));
        b.setAttribute('aria-current', 'true');
        if (window.BVI18n) BVI18n.usarMoeda(b.dataset.moeda);
        document.querySelectorAll('[data-gaveta-moeda]').forEach(x => x.toggleAttribute('aria-current', x.dataset.gavetaMoeda === b.dataset.moeda));
      }
      fecha();
      btn.focus({ preventScroll: true });
    });
    /* Moeda salva: marca a escolha no painel. */
    if (window.BVI18n && BVI18n.moeda !== 'EUR') {
      painel.querySelectorAll('[data-moeda]').forEach(x => x.toggleAttribute('aria-current', x.dataset.moeda === BVI18n.moeda));
    }
    /* Idioma salvo de uma visita anterior: a bandeira já nasce certa. */
    if (window.BVI18n && BVI18n.atual !== 'es') {
      marcaIdioma(BVI18n.atual);
      if (pais) pais.querySelector('use').setAttribute('href', '#b-' + BVI18n.atual);
    }
  })();

  /* --- Promessas (1.3.8 = protótipo, js/ui.js D5) -----------------------
     Lista fixa; quem muda é o painel. Os painéis vêm do Liquid dentro de
     #promessas-arte. No celular cada um desce para baixo do próprio título,
     numa caixa que anima a altura, e volta para a coluna quando a tela alarga. */
  (function promessas() {
    const ul = document.getElementById('promessas-ul');
    const arte = document.getElementById('promessas-arte');
    if (!ul || !arte) return;
    const botoes = Array.from(ul.querySelectorAll('.promessa'));
    const paineis = Array.from(arte.querySelectorAll('.painel'));
    if (!paineis.length) return;
    const caixas = paineis.map(function () {
      const c = document.createElement('div');
      c.className = 'painel-caixa';
      c.innerHTML = '<div class="painel-mola"></div>';
      return c;
    });
    function ativa(n) {
      botoes.forEach((b, k) => b.setAttribute('aria-expanded', String(k === n)));
      paineis.forEach((p, k) => p.classList.toggle('ativa', k === n));
      caixas.forEach((c, k) => c.classList.toggle('aberta', k === n));
    }
    const estreita = window.matchMedia('(max-width: 900px)');
    function posiciona() {
      paineis.forEach(function (p, k) {
        if (!botoes[k]) return;
        if (estreita.matches) {
          if (!caixas[k].parentElement) botoes[k].parentElement.appendChild(caixas[k]);
          caixas[k].classList.toggle('aberta', p.classList.contains('ativa'));
          const mola = caixas[k].firstElementChild;
          if (p.parentElement !== mola) mola.appendChild(p);
        } else if (p.parentElement !== arte) arte.appendChild(p);
      });
      if (!estreita.matches && !paineis.some(p => p.classList.contains('ativa'))) ativa(0);
    }
    posiciona();
    if (estreita.addEventListener) estreita.addEventListener('change', posiciona);
    const podeHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    botoes.forEach(function (b, k) {
      b.addEventListener('click', function () {
        const aberto = b.getAttribute('aria-expanded') === 'true';
        ativa(estreita.matches && aberto ? -1 : k);
      });
      b.addEventListener('mouseenter', () => { if (!reduz && podeHover && !estreita.matches) ativa(k); });
    });
  })();

  /* --- FAQ: acordeao + JSON-LD tirado da PROPRIA pagina ------------------
     O schema nasce das mesmas perguntas que a pessoa ve. Duas fontes
     divergem na primeira edicao. */
  (function faq() {
    /* Um aberto por vez. A altura anima por grid-template-rows no CSS
       (.faq__p[aria-expanded] + .faq__r); o JSON-LD vem do Liquid. */
    const alvo = document.getElementById('faq');
    if (!alvo) return;
    alvo.addEventListener('click', function (ev) {
      const b = ev.target.closest('.faq__p');
      if (!b) return;
      const abrir = b.getAttribute('aria-expanded') !== 'true';
      alvo.querySelectorAll('.faq__p[aria-expanded="true"]').forEach(o => o.setAttribute('aria-expanded', 'false'));
      b.setAttribute('aria-expanded', String(abrir));
    });
  })();

  /* --- D11 newsletter: validacao inline, erro ABAIXO do campo ------------ */
  (function news() {   /* o envio e do Shopify; aqui so a validacao visivel */
    const f = document.getElementById('news-form');
    if (!f) return;
    const email = document.getElementById('news-email');
    const erro = document.getElementById('news-erro');
    function falha(msg) {
      erro.textContent = msg; erro.hidden = false;
      email.setAttribute('aria-invalid', 'true'); email.focus();
    }
    f.addEventListener('submit', function (ev) {
      erro.hidden = true; email.removeAttribute('aria-invalid');
      if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(email.value.trim())) {
        ev.preventDefault(); return falha(((window.BV && BV.loja && BV.loja.textos) || {}).email_invalido || 'Ese e-mail parece incorrecto. ¿Lo revisas?');
      }
      if (!f.consent.checked) {
        ev.preventDefault(); return falha(((window.BV && BV.loja && BV.loja.textos) || {}).consentimento_news || 'Necesitamos tu autorización para escribirte.');
      }
      /* Valido: segue o envio normal para a Shopify ({% form 'customer' %}).
         O "gracias" vem do servidor (form.posted_successfully?), nao daqui. */
    });
  })();

  /* --- Cookies (tema 1.2) ------------------------------------------------
     Aceitar, Recusar e Configurar com o mesmo peso. A escolha vai para a
     Customer Privacy API da Shopify, que e quem de fato libera ou segura os
     apps de medicao. Retirar o consentimento apaga os cookies de medicao que
     o navegador ja tinha (AEPD PS/00524/2023: retirada que nao apaga nao e
     operativa). */
  (function cookies() {
    const cx = document.getElementById('cookies');
    const painel = document.getElementById('ck-prefs');
    const botaoRodape = document.getElementById('abrir-cookies');
    function comApi(fn) {
      const S = window.Shopify;
      if (S && S.customerPrivacy) return fn(S.customerPrivacy);
      if (S && S.loadFeatures) {
        S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (!err && window.Shopify.customerPrivacy) fn(window.Shopify.customerPrivacy);
        });
      }
    }
    /* Opt-out de venda de dados (EUA): so onde a Shopify diz que se aplica. */
    comApi(function (api) {
      if (api.saleOfDataRegion && api.saleOfDataRegion())
        document.querySelectorAll('[data-so-optout]').forEach(function (li) { li.hidden = false; });
    });
    if (!cx) {
      /* Banner nativo da Shopify em uso: o botao do rodape abre o dele. */
      if (botaoRodape) botaoRodape.addEventListener('click', function () {
        if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
      });
      return;
    }
    const COOKIES = {
      analytics: [/^_ga/, /^_gid$/, /^_gat/, /^_clck$/, /^_clsk$/, /^_shopify_s$/, /^_shopify_sa_/, /^_orig_referrer$/, /^_landing_page$/],
      marketing: [/^_fbp$/, /^_fbc$/, /^_gcl_/, /^_ttp$/, /^_pin_unauth$/, /^_uetsid$/, /^_uetvid$/]
    };
    function apagar(escolha) {
      const alvos = [];
      if (!escolha.analytics) alvos.push.apply(alvos, COOKIES.analytics);
      if (!escolha.marketing) alvos.push.apply(alvos, COOKIES.marketing);
      if (!alvos.length) return;
      const host = location.hostname, raiz = host.replace(/^www\./, '');
      document.cookie.split(';').forEach(function (c) {
        const nome = c.split('=')[0].trim();
        if (!alvos.some(function (r) { return r.test(nome); })) return;
        ['', ';domain=' + host, ';domain=.' + raiz].forEach(function (d) {
          document.cookie = nome + '=;Max-Age=0;path=/' + d;
        });
      });
    }
    function marcar(atual) {
      painel.querySelectorAll('input[data-cat]').forEach(function (i) {
        i.checked = !!atual && atual[i.dataset.cat] === 'yes';
      });
    }
    function abrir(comPainel) {
      cx.hidden = false;
      painel.hidden = !comPainel;
      if (comPainel) comApi(function (api) { if (api.currentVisitorConsent) marcar(api.currentVisitorConsent()); });
      const foco = cx.querySelector(comPainel ? 'input[data-cat]' : '[data-ck="aceitar"]');
      if (foco) foco.focus();
    }
    function gravar(escolha) {
      comApi(function (api) {
        api.setTrackingConsent({
          analytics: escolha.analytics,
          marketing: escolha.marketing,
          preferences: escolha.preferences,
          sale_of_data: escolha.marketing
        }, function () { apagar(escolha); });
      });
      cx.hidden = true;
      if (botaoRodape) botaoRodape.focus({ preventScroll: true });
    }
    cx.addEventListener('click', function (ev) {
      const b = ev.target.closest('[data-ck]');
      if (!b) return;
      const acao = b.dataset.ck;
      if (acao === 'aceitar') gravar({ analytics: true, marketing: true, preferences: true });
      else if (acao === 'recusar') gravar({ analytics: false, marketing: false, preferences: false });
      else if (acao === 'config') abrir(true);
      else if (acao === 'salvar') {
        const v = function (k) { return painel.querySelector('[data-cat="' + k + '"]').checked; };
        gravar({ analytics: v('analytics'), marketing: v('marketing'), preferences: v('preferences') });
      }
    });
    comApi(function (api) {
      if (api.shouldShowBanner && api.shouldShowBanner()) { cx.hidden = false; painel.hidden = true; }
    });
    if (botaoRodape) botaoRodape.addEventListener('click', function () { abrir(true); });
  })();

  /* --- Entrada de secao: IntersectionObserver, nao listener de scroll ---- */
  (function entrada() {
    const alvos = document.querySelectorAll('.entra');
    if (!alvos.length || reduz) {
      alvos.forEach(a => a.classList.add('dentro'));
      return;
    }
    const io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('dentro'); io.unobserve(en.target); }
      });
    /* ⚠️ LIMIAR ZERO (16/09/2026). Com 12% de uma vitrine de 3.400px, a
       pessoa rolava ~400px de seção INVISÍVEL até ela acender - era o
       "travadinha" entre as garantias e o catálogo. */
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    alvos.forEach(a => io.observe(a));
  })();

  /* --- Categorias (1.3.7, porte de prototipo/js/categorias.js) ----------
     O port para o tema trouxe o CSS e deixou o script para trás: no celular
     as linhas esperavam `.visto` e ficavam invisíveis; no desktop o hover
     não acendia a linha nem trazia a arte. A cor de cada bloco é a amostrada
     do canto de cada arte (JM, 17/09/2026). */
  (function categorias() {
    const bloco = document.getElementById('cats');
    if (!bloco) return;
    const fundo = document.getElementById('cats-fundo');
    const fotos = fundo ? Array.from(fundo.children) : [];
    const linhas = Array.from(bloco.querySelectorAll('.catlinha'));
    const COR = {
      'facial-corporal': '#1d033d', 'casa-cozinha': '#140225', 'saude-bemestar': '#1c033c',
      'eletronicos': '#1a0633', 'cabelo-barba': '#1d0e40', 'varios': '#1a0845',
      'maquiagem': '#20053d', 'fitness': '#1a0737', 'auto-ferramentas': '#190732',
      'infantil': '#1c053d', 'moda': '#180732', 'pet': '#21063b'
    };
    function acende(k) {
      bloco.style.setProperty('--cor', COR[linhas[k].dataset.handle] || '#1a0633');
      bloco.classList.add('aceso');
      linhas.forEach((l, i) => l.classList.toggle('acesa', i === k));
      fotos.forEach(f => f.classList.toggle('ativa', Number(f.dataset.i) === k));
    }
    function apaga() {
      bloco.classList.remove('aceso');
      linhas.forEach(l => l.classList.remove('acesa'));
      fotos.forEach(f => f.classList.remove('ativa'));
    }
    /* No toque o `mouseenter` também dispara e a linha acendia ao tocar. */
    const podeHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    linhas.forEach(function (l, k) {
      if (podeHover) l.addEventListener('mouseenter', () => acende(k));
      l.addEventListener('focusin', () => acende(k));
    });
    bloco.addEventListener('mouseleave', apaga);
    bloco.addEventListener('focusout', function (ev) { if (!bloco.contains(ev.relatedTarget)) apaga(); });
    /* No celular as linhas entram em cascata quando o bloco chega na tela. */
    if (reduz || !('IntersectionObserver' in window)) { bloco.classList.add('visto'); return; }
    const io = new IntersectionObserver(function (ents) {
      if (!ents[0].isIntersecting) return;
      bloco.classList.add('visto'); io.disconnect();
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    io.observe(bloco);
  })();

  /* Filtros da vitrine da home: mesma régua com dica de "deslize" da coleção. */
  (function reguaVitrine() {
    const f = document.querySelector('#vitrine #filtros');
    if (f && window.BV && BV.regua) BV.regua(f, false, true);
    /* 1.3.8: os chips filtram NO LUGAR (vitrine.js do protótipo). A grade da
       categoria vem da própria seção renderizada pela Shopify
       (<coleção>?section_id=vitrine); clique com ctrl/cmd segue o link. */
    if (f) f.addEventListener('click', function (ev) {
      const a = ev.target.closest('a[data-vf]');
      if (!a || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button) return;
      ev.preventDefault();
      if (a.getAttribute('aria-pressed') === 'true') return;
      f.querySelectorAll('a[data-vf]').forEach(c => c.setAttribute('aria-pressed', String(c === a)));
      const grade = document.getElementById('grade');
      grade.setAttribute('aria-busy', 'true');
      const u = new URL(a.href, location.origin);
      u.searchParams.set('section_id', 'vitrine');
      fetch(u).then(r => { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
        if (a.getAttribute('aria-pressed') !== 'true') return;          /* outro chip já foi clicado */
        const d = new DOMParser().parseFromString(html, 'text/html');
        ['grade', 'vitrine-conta', 'vitrine-mais'].forEach(function (id) {
          const novo = d.getElementById(id), velho = document.getElementById(id);
          if (novo && velho) velho.innerHTML = novo.innerHTML;
        });
        grade.setAttribute('aria-busy', 'false');
      }).catch(function () { location.href = a.href; });
    });
    /* 1.3.8: ofertas com a dica de "deslize" do protótipo (vitrine.js: BV.regua(ofertas)). */
    const o = document.getElementById('ofertas-grade');
    if (o && window.BV && BV.regua) BV.regua(o);
  })();

  /* --- Holofote e inclinação que seguem o ponteiro ----------------------
     Só com mouse. Um ouvinte para a página inteira, com um quadro por vez:
     escreve --mx/--my (posição) e --rx/--ry (inclinação) no cartão sob o
     ponteiro. Ver css/secoes.css, "Hover que não é sobe e desce". */
  (function ponteiro() {
    if (reduz || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    let alvo = null, ev = null, pedido = false;
    function aplica() {
      pedido = false;
      if (!alvo || !ev) return;
      const r = alvo.getBoundingClientRect();
      const x = (ev.clientX - r.left) / r.width, y = (ev.clientY - r.top) / r.height;
      alvo.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
      alvo.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      if (alvo.classList.contains('bcard__link')) {
        alvo.style.setProperty('--ry', ((x - .5) * 10).toFixed(2) + 'deg');
        alvo.style.setProperty('--rx', ((.5 - y) * 8).toFixed(2) + 'deg');
      }
    }
    document.addEventListener('pointermove', function (e) {
      const a = e.target.closest && e.target.closest('.depo__card, .bcard__link, .garantia, .numero');
      if (alvo && a !== alvo) { alvo.style.removeProperty('--rx'); alvo.style.removeProperty('--ry'); }
      alvo = a; ev = e;
      if (a && !pedido) { pedido = true; requestAnimationFrame(aplica); }
    }, { passive: true });
  })();

  /* --- Voltar para a página anterior (JM, 17/09/2026) --------------------
     Toda página interna nasce com um botão no topo. Ele volta no HISTÓRICO,
     que é o que a pessoa espera: de um artigo aberto pela home, volta para a
     home; aberto pela lista do blog, volta para a lista. Sem histórico (link
     colado, aba nova), cai num destino fixo por tipo de página. */
  (function voltar() {
    const alvo = document.querySelector('main.pdp, main.col, main.carrito, main.blog');
    if (!alvo || document.getElementById('bv-voltar')) return;
    /* O blog cuida dos seus: a lista já é destino, e o artigo monta o
       próprio botão (com o destino que o histórico disser). */
    if (alvo.dataset.blog) return;
    /* 1.3.7: 'index.html'/'catalogo.html' eram do protótipo e davam 404 na
       loja; o destino respeita o prefixo do idioma (/pt-pt/, /en-us/...). */
    const raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const padrao = alvo.classList.contains('col') || alvo.classList.contains('carrito') ? raiz : raiz + 'collections/all';
    /* 1.4.8: o rótulo vem do locale do idioma da página (BV.loja.textos),
       não mais de um dicionário de 4 idiomas — no croata aparecia 'Volver'. */
    const TX = (window.BV && BV.loja && BV.loja.textos) || {};
    const b = document.createElement('a');
    b.id = 'bv-voltar';
    b.className = 'voltar';
    b.href = padrao;
    b.innerHTML = '<span aria-hidden="true"></span>' + (TX.voltar || 'Volver');
    const env = alvo.querySelector('.env') || alvo.firstElementChild;
    (env && env.parentElement === alvo ? alvo : alvo).insertBefore(envolver(b), alvo.firstChild);
    b.addEventListener('click', function (ev) {
      /* Só usa o histórico quando ele existe dentro do site. */
      if (history.length > 1 && document.referrer && document.referrer.indexOf(location.origin) === 0) {
        ev.preventDefault();
        history.back();
      }
    });
    function envolver(el) {
      const d = document.createElement('div');
      d.className = 'env voltar__env';
      d.appendChild(el);
      return d;
    }
  })();

  const ano = document.getElementById('ano');
  if (ano) ano.textContent = new Date().getFullYear();
})();

/* 1.4.4 (02/10/2026): trocar de país troca o idioma. Todo botão de país com
   data-lingua (topo, menu, bloco da home) leva junto o language_code do país
   (o snippet lingua-pais só devolve idioma publicado; senão, inglês). */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('button[name="country_code"][data-lingua]');
  if (!b || !b.form) return;
  var i = b.form.querySelector('input[name="language_code"]');
  if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = 'language_code'; b.form.appendChild(i); }
  i.value = b.dataset.lingua;
}, true);
